import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ViewEncapsulation } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Store } from "@ngrx/store";
import { CommonState } from "@obg/ngx.common";
import { Observable } from "rxjs";
import { distinctUntilChanged, filter, map, skipUntil } from "rxjs/operators";

import { KycVerificationAction } from "./sdk/kyc-verification.action";
import { KycVerificationState } from "./sdk/kyc-verification.reducer";
import { KycVerificationSelector } from "./sdk/kyc-verification.selector";

@Component({
	selector: "obg-m-kyc-method-selection",
	templateUrl: "./kyc-method-selection.container.html",
	styleUrls: ["./kyc-method-selection.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class KycMethodSelectionContainer implements OnInit {
	@HostBinding("class.obg-m-kyc-method-selection-container") hostClass = true;

	safeUrl$: Observable<SafeResourceUrl | undefined> | undefined;
	height$: Observable<string> | undefined;

	constructor(
		private store: Store<CommonState & KycVerificationState>,
		private selector: KycVerificationSelector,
		private sanitizer: DomSanitizer
	) {}

	ngOnInit() {
		this.store.dispatch(KycVerificationAction.getKnowYourCustomerUrl());

		this.safeUrl$ = this.store.select(this.selector.getKnowYourCustomerUrl()).pipe(
			skipUntil(this.store.select(this.selector.isBusy())),
			filter((url) => !!url?.length),
			map((url: string) => this.sanitizer.bypassSecurityTrustResourceUrl(url))
		);

		this.height$ = this.store.select(this.selector.height()).pipe(
			distinctUntilChanged(),
			map((height) => `${height}px`)
		);
	}
}
